import { DISABLE_COGNITO_LOGIN } from "../config/constants";
import MetaDashboard from "../screens/dashboard/MetaDashboard";
import PasswordForgot from "../screens/forgotPassword/ForgotPassword";
import CognitoLogin from "../screens/login/CognitoLogin";
import Login from "../screens/login/Login";
import LogOut from "../screens/logOut/LogOut";
import MappingInteraction from "../screens/mapping_interaction/MappingInteraction";
import NotificationList from "../screens/notificationList/NotificationList";
import PasswordReset from "../screens/passwordReset/PasswordReset";
import Unauthorized from "../screens/unauthorized/Unauthorized";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

export const CommonRoutes = [
  {
    path: "/auth",
    route: DISABLE_COGNITO_LOGIN ? <Login /> : <CognitoLogin />,
    protectRoutes: false
  },
  {
    path: "/logout",
    route: <LogOut />,
    protectRoutes: false
  },
  {
    path: "/password-reset",
    route: <PasswordReset />,
    protectRoutes: false
  },
  {
    path: "/password-forgot",
    route: <PasswordForgot />,
    protectRoutes: false
  },
  {
    path: "/unauthorized",
    route: <Unauthorized />,
    protectRoutes: false
  },
  {
    path: "/",
    route: <MetaDashboard />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  },
  {
    path: "/mapping-interaction",
    route: <MappingInteraction />,
    protectRoutes: true,
    roleGrantAccess: [...supplierAccess, ...adminAccess, ...userAccess]
  },
  {
    path: "/notification",
    route: <NotificationList />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  }
];
